import { apiClient } from '../../client'

export interface NpdLookupOption {
  id: number
  en_name: string
  arrival_status?: string | null
  arrival_date?: string | null
}

export interface NpdStoreMappingPayload {
  store_id: number
  arrival_status?: string | null
  arrival_date?: string | null
}

export interface NpdLookupPayload {
  search?: string
  limit?: number
  filters?: {
    region_ids?: string
    city_ids?: string
    chain_ids?: string
    channel_ids?: string
    store_class_ids?: string
    category_ids?: string
    subcategory_ids?: string
    brand_ids?: string
  }
}

class NpdStoresRepository {
  async getSelected(npdBatchId: number): Promise<{ stores: NpdLookupOption[] }> {
    return apiClient.get<{ stores: NpdLookupOption[] }>(`/npd-stores/selected/${npdBatchId}`)
  }

  async lookup(data: NpdLookupPayload): Promise<NpdLookupOption[]> {
    return apiClient.post<NpdLookupOption[]>('/npd-stores/lookup', data, true, { silent: true })
  }

  async sync(
    npdBatchId: number,
    storeMappings: NpdStoreMappingPayload[],
  ): Promise<{ message: string; count: number }> {
    return apiClient.post<{ message: string; count: number }>('/npd-stores/sync', {
      npd_batch_id: npdBatchId,
      store_mappings: storeMappings,
    })
  }
}

export const npdStoresRepository = new NpdStoresRepository()
